export default "__VITE_ASSET__DkNnaOLz__"